import { CommonHTMLHelpStyle } from "../style/CommonHTMLHelpStyle";
/**
 * AbstractHTMLHelpProperties.ts
 */
export class AbstractHTMLHelpProperties {
    constructor() {
        this.setDefaultValues();
    }
    getKeyStyle() {
        return CommonHTMLHelpStyle;
    }
    setDefaultValues() {
        this.maxWinElements = ["help.slingo.standard.rules.line11"];
        this.pendingGameElements = ["pending"];
        this.playControlsGameElements = ["controls"];
        this.extraSpinElements = ["help.slingo.standard.extra.line4"];
        this.availableWinElements = ["couldwin"];
    }
}
//# sourceMappingURL=AbstractHTMLHelpProperties.js.map